export default __webpack_public_path__ + "static/media/eye.b99056d7.svg";